import React from 'react';
import PropTypes from 'prop-types';

import Img from '../Img';
import styles from './taPricingNotification.scss';

const TaPricingNotification = ({ savingsPercentage }) => {
    return (
        <div className={styles.tennisAustraliaSection} data-testid="ta-pricing-notification">
            <div className={styles.tennisAustraliaHeader}>
                <div className={styles.tennisAustraliaLogo}>
                    <Img src="/img/social/tennis-australia-logo.svg" alt="Tennis Australia" data-testid="ta-pricing-notification.logo" />
                </div>
                <div className={styles.tennisAustraliaText}>
                    <div className={styles.tennisAustraliaTitle} data-testid="ta-pricing-notification.title">
                        Tennis Australia members receive the best pricing. Save {savingsPercentage}% on Power.
                    </div>
                </div>
            </div>
        </div>
    );
};

TaPricingNotification.propTypes = {
    savingsPercentage: PropTypes.number,
};

TaPricingNotification.defaultProps = {
    savingsPercentage: 0,
};

export default TaPricingNotification;
